 import React, { useContext, useState, useEffect } from "react";
import GlobalContext from "../../context/GlobalContext";
import {  ProposalStatusUpdate, CreateAlert} from "../../utils/apiCalls";
import { getMonthDateYear, addDateDays } from "../../utils/addDays"; 
import ModalJobProposal from "../../components/JobProposal/ClientJobProposal";
import Message from "../../components/Message";   
import DOMPurify from 'isomorphic-dompurify';
import SendMessage from "../../components/Message/SendMessage";
import AlertUtils from "../../utils/AlertUtils";
import ReactCountryFlag from "react-country-flag";
import TablePagination from "../../components/Table/TablePagination";
import tableHelper from "../../components/Table/tableHelper";

export default function PostedJobs(props) {

    const gContext = useContext(GlobalContext);
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
    const [errorMessage, setErrorMessage] = React.useState('');
    const [proposalList, setProposalList] = useState([]);
    const [currentValue, setCurrentValue] = useState({ id: null });
    const [message, setMessage] = React.useState(false);
    const [proposalData, setproposalData] = useState({});
    const [proposalModalVisible, setProposalModalVisible] = useState(false);
    const [modalvisible, setmodalvisible] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [page, setPage] = useState(1);
    function GetLength(detail) {
        return DOMPurify.sanitize(detail?.replaceAll("''", "'").replaceAll("<br>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``)).length;
    }
    const { slice, range } = tableHelper(proposalList, page, gContext.paginationSize);
    const toggleProposalModal = () => {
        setProposalModalVisible(!proposalModalVisible);
    };
    const togglemodal = () => {
        setmodalvisible(!modalvisible);
    };
    function ViewProposal(data) {
        setproposalData(data);
        toggleProposalModal();
    }   
    function ViewMessage() {
       
        toggleProposalModal();
        togglemodal();
    }   

    const callConfirm = (mode, id,data) => {
       
        if (id) { 
                setproposalData(data);
                gContext.setconfirmModal({ header: " ", ["text"]: "Do you want to " + mode +" this proposal?", ["confirmed"]: false, id: id, showButton: true, mode: mode,page:"proposal" });
                gContext.toggleConfirmModal();
        } 
    }

    useEffect(() => {
        if (gContext.confirmModal.confirmed && gContext.confirmModal.page == "proposal") { 
            updateStatus(gContext.confirmModal.id, gContext.confirmModal.mode);   
            gContext.setconfirmModal({
                ...gContext.confirmModal, ["confirmed"]: false, ["id"]: null, ["page"]: ""
            });
        }
        else { setCurrentValue({ id: null, page: "" }); }
    }, [gContext.confirmModal]);

    const updateStatus = async (id, mode) => {
        gContext.setLoaderModalVisible(true);
        try {
            
            let status = (mode === "shortlist") ? 200 : (mode === "reject") ? 300 : 100;
                const result = await ProposalStatusUpdate(id, status );
               
            if (result.data.proposalStatusUpdate.responseData.code == "200") { 
                if (mode === "shortlist")
                   SendNotification();

                props.callbackUpdateProposal();
                } 
            }
        catch (e) {  
            console.log(e);
            gContext.setLoaderModalVisible(false);
        } 
        gContext.setLoaderModalVisible(false);
    } 
    async function SendNotification() {

        const profileInfo = JSON.parse(gContext.userInfo.profileInfo);
        

        try {
            //[EXPERTSUB],[EXPERTNAME],[JOBTITLE],[JOBGUID]
            const alert = AlertUtils.ProposalShortListed.
                replace("[CLIENTSUB]", gContext.userInfo.sub).
                replace("[COMPANY]", (profileInfo && profileInfo.length > 0) ? profileInfo[0].company:"").
                replace("[JOBTITLE]", proposalData.title).
                replace("[JOBGUID]", proposalData.guid);
           

            const result = await CreateAlert({ id: null, alert: alert.replaceAll("\"", "''"), alertType: "Job", display: true, status: 'N', toTypeId: 1, toUserId: proposalData.expertid });

            if (result.data.createAlert.responseData.code == "200") {
                 
            }

            gContext.setLoaderModalVisible(false);
        }
        catch (e) {
            console.log(e);
            gContext.setLoaderModalVisible(false);
            setErrorMessage("Server error");
        }

    }
    function LoadProposal() {
        try {
            if (props.proposalData) {
                setPage(1);
                let data;
                if (props.mode === "open" || props.mode === "job") {
                    if (props.id)
                        data = props.proposalData.open.filter(item => item["guid"] == props.id);
                    else
                        data = props.proposalData.open;
                }
                else if (props.mode === "shortlisted") {
                    if (props.id)
                        data = props.proposalData.shortlisted.filter(item => item["guid"] == props.id);
                    else
                        data = props.proposalData.shortlisted;

                }
                else if (props.mode === "withdrawn") {
                    if (props.id)
                        data = props.proposalData.withdrawn.filter(item => item["guid"] == props.id);
                    else
                        data = props.proposalData.withdrawn;

                }
                else if (props.mode === "archived") {
                    if (props.id)
                        data = props.proposalData.archived.filter(item => item["guid"] == props.id);
                    else
                        data = props.proposalData.archived;

                }
                else {
                    if (props.id)
                        data = props.proposalData.rejected.filter(item => item["guid"] == props.id);
                    else
                        data = props.proposalData.rejected;

                }
                console.log("dataproposal", data);
                setProposalList(data);
                setLoaded(true);
            }
        }
        catch (e) {
            console.log(e);

        }
    }
    useEffect(() => {
        
        LoadProposal(); 
    }, [props.proposalData]);

    useEffect(() => {
         
        LoadProposal(); 
    }, [props.mode]);

    useEffect(() => { 
        document.title = "Proposals | Syncuppro";
    }, []);
    return (
        <>
       

                            {message && <div className="col-lg-12 col-xl-12 text-left ml-6">
                                <Message message="Job deleted successfully" />
                            </div>}
                       
            {(loaded && proposalList && proposalList.length == 0) && <div className="d-flex flex-column align-item-center justify-content-center">
                <span className="text-light-gray m-icon material-icons m-b-10">work</span>
                <span>No proposal found</span>
            </div>}
            {(loaded && proposalList && proposalList.length > 0) &&

                <>
                <div className="accordion" id="accordionProposals">
                    {slice && slice.map((data, index) => {
                       
                    return (
                        <div className="accordion-wrapper accordion-dashboard" key={index} id={"proposals" + index} >
                            <a className={index == 0 ? "accordion-btn  p-5 " : "accordion-btn  p-5 collapsed m-t-10"} data-toggle="tooltip" title="Click to view proposal details" data-bs-toggle="collapse" href={"#accordion-proposals" + index} aria-expanded={index == 0 ? "true" : "false"} > <b>   {(data.datemodified && (addDateDays(new Date(), -7) < new Date(data.datemodified))) ? <div className="d-flex justify-content-center align-items-center">   <img src="../images/new.PNG" className=" w-30 m-r-10" alt="" /> <span className="pointer" >{data.title}</span></div> : <><span className="pointer" data-toggle="tooltip" title="Click to view Job details" >{data.title}</span></>}</b>
                                <span className="m-icon material-icons indicator show">expand_more</span>
                                <span className="m-icon material-icons indicator hide">expand_less</span>
                            </a>
                            <div id={"accordion-proposals" + index} className={index == 0 ? "collapse show  " : "collapse  "} data-bs-parent="#accordionProposals"  >
                                <div className="accordion-body card panel p-10 ">

                                    <div className="  m-b-20">
                                        <div className="row" >
                                            <div className="icon-frame d-flex m-r-5">
                                                <div className="info-meta company pointer w-full    " data-toggle="tooltip" title="Click to view expert details" onClick={(e) => { window.location.href = "/expert/" + data.sub; }}   >
                                                    <img className="m-r-0  " src={s3URL + data.avatar} alt={""} id={"image" + index} onError={(img) => { img.target.src = '../../images/user-default.png'; }} />
                                                    <span className="one-line text-black m-l-5"><b>{data.firstname + ' ' + data.lastname}</b> </span>
                                                </div>
                                            </div>   
                                            <div className="company-post m-b-10">
                                                     

                                                        <div className="d-flex flex-column m-l-25">
                                                            
                                                            <div className="info-meta flag m-r-20">
                                                                <span className="text-theme m-icon material-icons m-r-5">location_on</span><span className="one-line text-black m-r-5">
                                                                    <span className={`    ${(data.city != null && data.city.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.city ? data.city.toLowerCase() : "" + ' '}</span>
                                                                    {''}    <span className={`    ${(data.state != null && data.state.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.state ? data.state.toLowerCase() : ""}</span>{' ' + data.countrycode}</span>

                                                                <ReactCountryFlag
                                                                    countryCode={(data.countrycode) ? data.countrycode : ''}
                                                                    svg
                                                                    style={{
                                                                        width: '1em',
                                                                        height: '.7em',
                                                                    }}
                                                                    title={(data.countryname) ? data.countryname : ''}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                            <div className="col-lg-12  col-md-12 col-sm-12  pointer" data-toggle="tooltip" title="Click to view proposal details" onClick={() => { ViewProposal(data); }}>
                                                {data.cover_letter &&
                                                    <div className=" heading-default-color m-b-10 " dangerouslySetInnerHTML={{ __html: (GetLength(data.cover_letter) > 350 ? DOMPurify.sanitize((data.cover_letter.replaceAll("''", "'").replaceAll("<br>", "").replaceAll("<br/>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``))).slice(0, 350) + " ...  " : DOMPurify.sanitize((data.cover_letter.replaceAll("''", "'").replaceAll("<br>", "").replaceAll("<br/>", "").replaceAll(`<p>`, ``).replaceAll(`</p>`, ``)))) }}></div>
                                                } </div>
                                            <div className="col-lg-12 col-md-6 col-sm-12">  <div className="info-meta m-t-5">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">attachment</span> <span  ><b>Attachment :</b>         {data.attachments && data.attachments !== "" &&


                                                    <a href={s3URL + data.attachments} rel="noopener noreferrer" target="_blank" data-toggle="tooltip" title="Click here to view.">  <img src="../images/file.png" htmlFor="idUpload" className="w-30" /> </a>

                                                }
                                                    {!data.attachments && <> N/A</>}

                                                </span>
                                            </div></div>

                                            <div className="col-lg-4 col-md-6 col-sm-12 d-none">  <div className="info-meta m-t-10 d-flex">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">place</span>  <b>Location :</b>
                                                <ReactCountryFlag
                                                    countryCode={data.countrycode}
                                                    svg
                                                    style={{
                                                        width: '1.5em',
                                                        height: '.7em',
                                                    }}
                                                    title={data.countrycode}
                                                />
                                                <span className="one-line text-black m-l-5 pointer" data-toggle="tooltip" title={data.city.toLowerCase() + ' ' + data.state.toLowerCase() + ' ' + data.countrycode} > <span className={`    ${(data.city != null && data.city.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.city.toLowerCase() + ' '}</span> <span className={`    ${(data.state != null && data.state.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.state.toLowerCase()}</span> {' ' + data.countrycode}</span>

                                            </div></div>

                                           

                                            <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">attach_money</span>  <span  ><b>Rate :</b>  ${(data.dailyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.dailyrate)) : ((data.fixedrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.fixedrate)) : (data.hourlyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.hourlyrate)) : (data.ratefrom && data.rateto) ? new Intl.NumberFormat('en-US').format(parseInt(data.ratefrom)) + ' - ' + new Intl.NumberFormat('en-US').format(parseInt(data.rateto)) : '-')}  </span>
                                            </div></div>
                                            <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">attach_money</span>  <span  ><b>Bid Rate :</b>   ${(data.bid) ? new Intl.NumberFormat('en-US').format(parseInt(data.bid)) : '-'} </span>
                                            </div></div>
                                            
                                            <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>   <span  ><b>Submitted on :</b>   {(data.statuscode === 500 || data.statuscode === 400 || data.statuscode === 300) ? ((data.datecreated) ? getMonthDateYear(data.datecreated) : "-") : (data.datecreated ? getMonthDateYear(data.datecreated) : "-")}</span>
                                            </div></div>
                                            {props.mode != "open" && <div className="col-lg-4 col-md-6 col-sm-12">  <div className="info-meta m-t-10">
                                                <span className="text-theme m-icon material-icons f-20 m-r-5">timer</span>   <span><b> {(props.mode === "shortlisted") ? "Shortlisted on" : (props.mode === "withdrawn") ? "Withdrawn on" : (props.mode === "archived") ? "Archived on" : (props.mode === "rejected") ? "Rejected on" : ''} :</b>   {(data.statuscode === 200 || data.statuscode === 500 || data.statuscode === 400 || data.statuscode === 300) ? ((data.datemodified) ? getMonthDateYear(data.datemodified) : "-") : ''}</span>
                                            </div></div>}
                                        </div>
                                        <div className="d-flex m-t-10 action-btns">
                                            {(props.mode === "open" || props.mode === "job") &&
                                                <>



                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => (ViewProposal(data))}>
                                                        View</button>
                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => (callConfirm('shortlist', data.id, data))}>
                                                        ShortList</button>
                                                <button className="btn btn-sm btn-orange m-r-10" onClick={() => (callConfirm('reject', data.id, data))}>Reject</button>
                                                </>
                                            }

                                            {props.mode === "shortlisted" &&


                                                <>


                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => (ViewProposal(data))}>
                                                    View</button>
                                                <button className="btn btn-sm btn-green m-r-10" style={{ width: "120px" }} onClick={() => (ViewProposal(data))}>
                                                        Make an Offer</button>
                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => { setproposalData(data); togglemodal(); }}>
                                                        Message</button>
                                                <button className="btn btn-sm btn-orange m-r-10" onClick={() => (callConfirm('reject', data.id, data))}>
                                                        Reject</button>
                                                </>
                                            }

                                            {props.mode === "rejected" && <>
                                                <button className="btn btn-sm btn-orange m-r-10" onClick={() => (ViewProposal(data))}>
                                                    View</button>
                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => (callConfirm('reopen', data.id, data))}>
                                                    Reopen</button>
                                            </>
                                            }
                                            {(props.mode === "withdrawn" || props.mode === "archived") &&
                                                <button className="btn btn-sm btn-green m-r-10" onClick={() => (ViewProposal(data))}>
                                                    View</button>}

                                        </div>
                                        <div className="expert-link d-flex justify-content-end">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                })}
                </div>

                <div className="table-responsive d-none">
                <table className="table table-striped">



                    <thead>
                            <tr>
                        <th></th>
                            <th
                                    className="w-200 min-lg-cell"
                            >
                                Job Title
                        </th>
                            <th
                                    className="w-200  min-lg-cell"
                            >
                                Applicant
                                </th> <th className="w-150  min-lg-cell"
                               
                            >
                                Location
                        </th>
                                <th className="  min-lg-cell d-none"
                                
                            >
                                Experience
                       </th>
                            <th
                                    className="w-150   min-lg-cell"
                            >
                                Rate 
                        </th>
                            <th
                                    className="  min-lg-cell"
                            >
                                Bid Rate 
                        </th>
                                <th className="  min-lg-cell">
                                Submitted on
                            </th>
                                <th className="  min-lg-cell">
                                {(props.mode === "shortlisted") ? "Shortlisted on" :(props.mode === "withdrawn") ? "Withdrawn on" : (props.mode === "archived") ? "Archived on" : (props.mode === "rejected") ? "Rejected on" : ''}
                            </th>
                                <th className="  min-lg-cell"
                                
                            ></th>


                        </tr>
                    </thead> 

                       
                        <tbody>
                        {slice && slice.map((data, index) => {

                            return (


                                <tr key={index} >

                                    <td className="m-0 p-0">  {data.datemodified && (addDateDays(new Date(), -7) < new Date(data.datemodified)) && <div className="d-flex justify-content-center align-items-center w-30">   <img src="../images/new.PNG" alt="" /></div>}</td>
                                       
                                    <td> 
                                         
                                        <span className="d-flex justify-content-left align-items-left" onClick={() => { window.location.href = "job/" + data.guid; }}>
                                            <span className="title    d-flex  pointer" data-toggle="tooltip" title={data.title} ><span className="one-line">{data.title}</span>  </span>
                                                    
                                                </span>
                                            </td>
                                       
                                       
                                       
                                        <td className="d-none">
                                        <div className="d-flex justify-content-left align-items-left">
                                            <div className="info-meta company pointer" data-toggle="tooltip" title={data.title} >  <span className=" table-title one-line text-black pointer" onClick={() => {window.location.href= "job/" + data.guid; }}>
                                                {data.title} </span> 
                                            </div></div>
                                    </td>
                                    <td>

                                        <div className="d-flex justify-content-center align-items-center">
                                            <div className="info-meta company pointer" onClick={(e) => { window.location.href = "/expert/" + data.sub; }}   >
                                                <img className="m-r-10 " id={"img"+index} src={s3URL + data.avatar} onError={(img) => { img.target.src = '../images/user-default.png'; }} alt=""/>
                                                <span className="one-line text-black ">{data.firstname + ' ' + data.lastname} </span>  
                                            </div>

                                           
                                        </div>
                                    </td>
                                        <td>
                                            <div className="info-meta flag">
                                                <ReactCountryFlag
                                                countryCode={data.countrycode}
                                                    svg
                                                    style={{
                                                        width: '1.5em',
                                                        height: '.7em',
                                                    }}
                                                    title={data.countrycode}
                                                />
                                            <span className="one-line text-black m-l-5 pointer" data-toggle="tooltip" title={data.city.toLowerCase() + ' ' + data.state.toLowerCase() + ' ' + data.countrycode } > <span className={`    ${(data.city != null && data.city.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.city.toLowerCase() + ' '}</span> <span className={`    ${(data.state != null && data.state.length > 2) ? 'text-capi' : 'text-upper'}`}>{data.state.toLowerCase()}</span> {' ' + data.countrycode}</span>
                                            </div>
                                        </td>
                                    <td className="d-none"> {data.experienclevel}</td>
                                        <td>
                                       ${(data.dailyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.dailyrate)) : ((data.fixedrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.fixedrate)) : (data.hourlyrate) ? new Intl.NumberFormat('en-US').format(parseInt(data.hourlyrate)) : (data.ratefrom && data.rateto) ? new Intl.NumberFormat('en-US').format(parseInt(data.ratefrom)) + ' - ' + new Intl.NumberFormat('en-US').format(parseInt(data.rateto)) : '-')}
                                        </td>
                                        <td>
                                       ${(data.bid) ? new Intl.NumberFormat('en-US').format(parseInt(data.bid)) : '-'}
                                        </td>
                                        <td>
                                        {(data.statuscode === 500 || data.statuscode === 400 || data.statuscode === 300) ? ((data.datecreated) ? getMonthDateYear(data.datecreated) : "-") : (data.datecreated ? getMonthDateYear(data.datecreated) : "-")}</td>
                                        
                                        <td>
                                        {( data.statuscode === 200 || data.statuscode === 500 || data.statuscode === 400 || data.statuscode === 300) ? ((data.datemodified) ? getMonthDateYear(data.datemodified) : "-") : ''}</td>
                                        
                                        <td>
                                        <div className="btn-table">

                                            {(props.mode === "open" || props.mode === "job") &&
                                                <>



                                                <button className="btn btn-sm btn-gray"  onClick={() => (ViewProposal(data))}>
                                                    View</button>
                                                <button className="btn btn-sm btn-gray"  onClick={() => (callConfirm('shortlist', data.id, data))}>
                                                    ShortList</button>
                                                <button className="btn btn-sm btn-gray"  onClick={() => (callConfirm('reject', data.id, data))}>Reject</button>
                                            </>
                                               }

                                            {props.mode === "shortlisted" &&


                                                <>



                                                <button className="btn btn-sm btn-gray" style={{ width:"120px" }} onClick={() => (ViewProposal(data))}>
                                                        Make an Offer</button>
                                                <button className="btn btn-sm btn-gray"  onClick={() => { setproposalData(data); togglemodal(); }}>
                                                    Message</button>
                                                <button className="btn btn-sm btn-gray"  onClick={() => (callConfirm('reject', data.id, data))}>
                                                    Reject</button>
                                                </>
                                            }

                                            {props.mode === "rejected" && <>
                                                <button className="btn btn-sm btn-gray"  onClick={() => (ViewProposal(data))}>
                                                    View</button>
                                                <button className="btn btn-sm btn-gray"  onClick={() => (callConfirm('reopen', data.id, data))}>
                                                    Reopen</button>
                                            </>
                                                }
                                            {(props.mode === "withdrawn" || props.mode === "archived") &&
                                                <button className="btn btn-sm btn-gray"  onClick={() => (ViewProposal(data))}>
                                                    View</button>}

                                            </div>
                                        </td>
                                    </tr>)
                            })}</tbody>
                    </table>
                </div>
                {(loaded && proposalList && proposalList.length > 5) && <TablePagination range={range} slice={slice} setPage={setPage} page={page} />}


                </>
                             }
                   
            {modalvisible && <SendMessage userdata={proposalData} modalvisible={modalvisible} togglemodal={togglemodal} />}
            {proposalModalVisible && <ModalJobProposal mode={props.mode} proposaldata={proposalData} id={proposalData.guid} proposalmodalvisible={proposalModalVisible} toggleproposalmodal={toggleProposalModal} viewmessage={ViewMessage} callFunction={(callMode, actionId, data) => { callConfirm(callMode, actionId, data);} } />}
        </>
    );
};